let activeScrollListener = null;

document.addEventListener("turbo:load", function() {

    const navbar = document.getElementById('masthead');
    let lastScrollTop = 0;
    let navHidden = false;
    let scrollScheduled = false;

    // Drop the previous page's listener so it doesn't accumulate across
    // Turbo navigations.
    if (activeScrollListener) {
        window.removeEventListener('scroll', activeScrollListener);
        activeScrollListener = null;
    }

    function handleScroll() {
        const scrollTop = document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            hideNavbar();
        } else if (scrollTop < lastScrollTop - 5) {
            showNavbar();
        }

        lastScrollTop = scrollTop;
    }

    function scheduleScroll() {
        if (scrollScheduled) return;

        scrollScheduled = true;
        requestAnimationFrame(function() {
            scrollScheduled = false;
            handleScroll();
        });
    }

    function hideNavbar() {
        if(!navHidden) {
            navbar.style.top = `-${navbar.offsetHeight}px`;
            navHidden = true;
        }
    }

    function showNavbar() {
        if(navHidden) {
            navbar.style.top = '0';
            navHidden = false;
        }
    }

    if (navbar) {
        if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            window.addEventListener('scroll', scheduleScroll, { passive: true });
            activeScrollListener = scheduleScroll;
        }
    }
});
